import { queryOptions, useQuery } from '@tanstack/react-query';

import { policiesApi } from '../api/policies-api';

import { policyKeys } from './policy-keys';

export function policiesQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: policyKeys.list(storeId),
    queryFn: () => policiesApi.list(storeId),
  });
}

export function usePolicies(storeId: string) {
  return useQuery(policiesQueryOptions(storeId));
}
